// extracted by mini-css-extract-plugin
export default {"container":"mac_container__PLhkI","box":"mac_box__ZiK18","main":"mac_main__ixmmp","more":"mac_more__4CTEK"};